import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=ef88916a&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"
import style0 from "./loginPage.vue?vue&type=style&index=0&id=ef88916a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef88916a",
  null
  
)

export default component.exports